import axios, { AxiosResponse, AxiosError } from 'axios';
import { dispatchUnauthorized } from 'core/constants/AuthEvents';
import { getAccessToken } from 'core/auth/accessTokenStorage';

export const baseURL = process.env.REACT_APP_BASE_API;
export const frontUrl = process.env.REACT_APP_FRONT_URL;

const client = axios.create({
  baseURL: baseURL + '/api',
  timeout: 15000,
});

client.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

client.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      dispatchUnauthorized();
    }
    return Promise.reject(error);
  }
);

export default client;
